/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface UpdateAddressDto
 */
export interface UpdateAddressDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    street1?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    street3?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    streetNo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAddressDto
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAddressDto
     */
    isResidential?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAddressDto
     */
    addressType?: UpdateAddressDtoAddressTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateAddressDtoAddressTypeEnum {
    Billing = 'Billing',
    Shipping = 'Shipping',
    Both = 'Both'
}

